import { useMemo, useState } from "react";
import type { Video } from "@/types/video";
import { getAllVideos } from "@/utils/video";
import VideoCard from "@/components/feature/VideoCard";

const PAGE_SIZE = 8;

export default function LatestUploads() {
  const [visible, setVisible] = useState(PAGE_SIZE);

  const sorted = useMemo<Video[]>(
    () =>
      [...getAllVideos()].sort(
        (a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
      ),
    []
  );

  const list = sorted.slice(0, visible);
  const hasMore = visible < sorted.length;

  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10 bg-background-100 border-y border-background-200">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-900">
            最新上传
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按发布时间倒序排列，实时更新</p>
        </div>
      </div>

      {list.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {list.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      ) : (
        <div className="py-16 text-center text-foreground-500 text-sm">暂无视频内容</div>
      )}

      <div className="mt-8 flex justify-center">
        {hasMore ? (
          <button
            type="button"
            onClick={() => setVisible((v) => v + PAGE_SIZE)}
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-down-line"></i>
            加载更多
          </button>
        ) : (
          <span className="text-sm text-foreground-400">已经到底啦，去看点别的吧</span>
        )}
      </div>
    </section>
  );
}